import { render, staticRenderFns } from "./chart12.vue?vue&type=template&id=0b5c24b2"
import script from "./chart12.vue?vue&type=script&lang=js"
export * from "./chart12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports